module.exports = __webpack_public_path__ + "static/img/quxian.c393ee9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/quxian.png
// module id = +qiq
// module chunks = 69